import Link from "next/link"
import React from "react"

/**
 * this component provides the sub-boxes within the project-workflow, especially used for linking to the pubtools
 */

interface IProps {
  href: string
  title: string
}

const ProgressSubBox: React.FC<IProps> = (props: IProps) =>
  <>
    <Link href={props.href}>
      <a className="sub-workflow__box">
        <h3>
          {props.title}
        </h3>
      </a>
    </Link>
  </>

export default ProgressSubBox
